"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("src/redux/actions");
function useHeightObserver(ref) {
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        const resizeObserver = new ResizeObserver(() => {
            dispatch((0, actions_1.heightChanged)());
        });
        resizeObserver.observe(ref.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, [dispatch, ref]);
}
exports.default = useHeightObserver;
